import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { hasModelLockExpired } from 'reducers/models/selectors';
import { resetModelLockExpired } from 'reducers/models/actions';
import { mini } from 'reducers/dashboard/selectors';
import styles from './styles.module.scss';

const mapStateToProps = combineSelectors({
  hasModelLockExpired,
  mini,
});

export const buttonStyle = ({ mini }) =>
  mini ? styles.miniButton : styles.bmwButton;

const mapDispatchToProps = { resetModelLockExpired };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  addProps({ buttonStyle }),
);
